import { AppdataService } from './../../services/app-data/appdata.service';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { $b } from '../../../libs/browser_utils.js';
import { CommunicationInterfaceService } from 'src/app/services/communicationInterface/communication-interface.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  title: string;
  message: string;
  actionsToRight: boolean;
  confirmToRight: boolean;
  appConfig: any;
  singleAction: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogModel>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogComponent,
    private appdataService: AppdataService,
    private commInterface: CommunicationInterfaceService
  ) {
    try {
      this.title = data.title;
      this.message = data.message;
      if ($b.IsValidJson(this.message)) {
        this.singleAction = JSON.parse(this.message).singleAction;
        this.message = '';
      }
      this.appConfig = this.appdataService.getConfig();
      this.actionsToRight = this.appConfig.Miscellaneous?.ButtonArrangement?.actionsToRight;
      this.confirmToRight = this.appConfig.Miscellaneous?.ButtonArrangement?.confirmToRight;
    } catch (error) {
      console.error('%c Error Occured in constructor', 'color: red', error);
      this.commInterface.sendUIErrors('ConfirmdialogComponent', 'constructor', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in ConfirmdialogComponent.constructor',
        JSON.stringify(error)
      );
    }
  }

  /**
   * Method to close the confirm dialog with positive selection (true)
   */
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  /**
   * Method to close the confirm dialog with negative selection (false)
   */
  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {
  constructor(public title: string, public message: string) {}
}
